import * as React from "react"
import { Box } from "@mui/material"

import { LabelCountry } from "@components"


/** `RRSP.market` is `varchar(2)`: unlike the retailer branch, `ES_CA` cannot live here. */
export default function marketColumn() {
    return {
        name: 'market', label: 'Market',
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRenderLite: value => <Box display="flex" justifyContent="center">
                {value ? <LabelCountry country={value} label={value} /> : '—'}
            </Box>
        }
    }
}
